// extracted by mini-css-extract-plugin
export default {"container":"Qca-z","oos":"Rca-z","oosUx":"Sca-z","selected":"Tca-z","labelOos":"Uca-z"};